var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-bar", class: { visible: _vm.visible } },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchTerm,
            expression: "searchTerm"
          }
        ],
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.searchTerm },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.buttonClick($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchTerm = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "search-toggle",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.buttonClick($event)
            }
          }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }